import { render, staticRenderFns } from "./attributeView.vue?vue&type=template&id=074e93d4&"
import script from "./attributeView.vue?vue&type=script&lang=js&"
export * from "./attributeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports